

function DashboardFooter() {
    return (
        <footer class="row bg-light mt-5 py-2 dash-footer ">
            <p class="text-center ">Copyright © Winay Tech 2026</p>
        </footer>
    );
}

export default DashboardFooter;